import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

export default function Dot(props) {
  const {
    color: backgroundColor,
    children,
    ...rest
  } = props || {};
  return (
    <div
      {...ex('Dot', rest)}

    >
      <div
        {...{
          style: {
            backgroundColor,
          },
        }}
      />
      {children}
    </div>
  );
}

